const ThankYou = ({ message, conformationType }) => {

    return (
        <>
            <section className="py-3">
                <div className="container">
                    <div className="row pt-5">
                        <div className="col-12 mb-5 text-center">
                            <div className="thankyou-img">
                                <img
                                    src={conformationType === 'EXPIRED' ? "images/expire.svg" : conformationType === 'CANCEL' ? "images/cancel.png" : "images/thank-you.png"}
                                    className="img-fluid"
                                    style={{ maxWidth: 100 }}
                                    alt=''
                                />
                            </div>
                            <div className="thankyou-text mt-2">
                                <h3 className="main-heading">{conformationType === 'EXPIRED' ? <p className='text-danger fw-bold'>Payment Link has been Expired.! </p> : conformationType === 'CANCEL' ? '' : ("Thank you")}</h3>
                                <p className='fw-bold' style={{ fontSize: '12px' }}>{conformationType === 'EXPIRED' ?'':message}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default ThankYou;